exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-releases-voice-to-text-js": () => import("./../../../src/pages/releases/voice-to-text.js" /* webpackChunkName: "component---src-pages-releases-voice-to-text-js" */),
  "component---src-pages-void-end-js": () => import("./../../../src/pages/void/end.js" /* webpackChunkName: "component---src-pages-void-end-js" */),
  "component---src-pages-void-index-js": () => import("./../../../src/pages/void/index.js" /* webpackChunkName: "component---src-pages-void-index-js" */)
}

